export class Sc4ErrorMessageListCheck {
  public static readonly type = '[Sc4ErrorMessageList] Check';
  constructor(public payload: string) {}
}

export class Sc4ErrorMessageListInitialState {
  public static readonly type = '[Sc4ErrorMessageList] Set initial state';
}
